export const locale = {
  lang: 'th-TH',
  data: {},
};
